import React from 'react'

export const WithdrawBankSvg = () => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M13.5415 2.7548C13.8227 2.58173 14.1774 2.58173 14.4587 2.7548L25.8337 9.7548C26.1671 9.95997 26.3236 10.3616 26.217 10.7383C26.1104 11.115 25.7665 11.375 25.3751 11.375L2.62507 11.375C2.2336 11.375 1.88976 11.115 1.78315 10.7383C1.67653 10.3616 1.83309 9.95997 2.16649 9.7548L13.5415 2.7548ZM5.71649 9.625L22.2837 9.625L14.0001 4.52741L5.71649 9.625Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M6.12598 9.625C6.60923 9.625 7.00098 10.0168 7.00098 10.5L7.00098 19.25C7.00098 19.7333 6.60923 20.125 6.12598 20.125C5.64273 20.125 5.25098 19.7333 5.25098 19.25L5.25098 10.5C5.25098 10.0168 5.64273 9.625 6.12598 9.625Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.374 9.625C11.8573 9.625 12.249 10.0168 12.249 10.5L12.249 19.25C12.249 19.7333 11.8573 20.125 11.374 20.125C10.8908 20.125 10.499 19.7333 10.499 19.25L10.499 10.5C10.499 10.0168 10.8908 9.625 11.374 9.625Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M16.625 9.625C17.1082 9.625 17.5 10.0168 17.5 10.5V19.25C17.5 19.7333 17.1082 20.125 16.625 20.125C16.1418 20.125 15.75 19.7333 15.75 19.25L15.75 10.5C15.75 10.0168 16.1418 9.625 16.625 9.625Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M21.876 9.625C22.3592 9.625 22.751 10.0168 22.751 10.5V19.25C22.751 19.7333 22.3592 20.125 21.876 20.125C21.3927 20.125 21.001 19.7333 21.001 19.25V10.5C21.001 10.0168 21.3927 9.625 21.876 9.625Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M2.625 19.2461C2.625 18.7628 3.01675 18.3711 3.5 18.3711L24.5 18.3711C24.9832 18.3711 25.375 18.7628 25.375 19.2461C25.375 19.7293 24.9832 20.1211 24.5 20.1211L3.5 20.1211C3.01675 20.1211 2.625 19.7293 2.625 19.2461Z'
        fill='white'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M0.875 22.7461C0.875 22.2628 1.26675 21.8711 1.75 21.8711L26.25 21.8711C26.7332 21.8711 27.125 22.2628 27.125 22.7461C27.125 23.2293 26.7332 23.6211 26.25 23.6211L1.75 23.6211C1.26675 23.6211 0.875 23.2293 0.875 22.7461Z'
        fill='white'
      />
    </svg>
  )
}
